<template lang="html">
  <div class="i-body">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'i-body',
};
</script>

<style lang="scss" scoped>
.i-body {
  position: absolute;
  top: 45px;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
